import React, { useState } from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import './Login.css';

function CCHLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPass, setShowPass] = useState(false);
  const [message, setMessage] = useState(null);

  const handleLogin = async (e) => {
    e.preventDefault();
    setMessage(null);

    try {
      const response = await fetch('https://www.fro.ro/api/cch/login.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();
      if (data.success) {
        localStorage.setItem('cchToken', data.token);
        localStorage.setItem('cchData', JSON.stringify(data.user));

        window.location.href = 'https://www.fro.ro/app/cch/dashboard';
        return;
      }

      else {
        setMessage(data.message || 'Autentificare eșuată');
      }
    } catch (error) {
      setMessage('Eroare la conexiune');
    }
  };

  return (
    <div className="login-bg">
      <div className="login-card">
        <div className="login-logo">Federația Română de Orientare</div>

        <h2 className="login-title">
          Comisia de Competiții &amp; Hărți
        </h2>

        <form onSubmit={handleLogin} className="login-form">
          <label className="login-label">Email</label>
          <input
            type="email"
            className="login-input"
            placeholder="Introduceți emailul"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
          />

          <label className="login-label" style={{ marginTop: 16 }}>
            Parolă
          </label>

          <div className="login-input-group">
            <input
              type={showPass ? 'text' : 'password'}
              className="password-input"
              placeholder="Introduceți parola"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
            />
            <span
              className="login-eye"
              onClick={() => setShowPass(v => !v)}
              tabIndex={0}
              style={{ cursor: 'pointer' }}
            >
              {showPass ? <FaEyeSlash /> : <FaEye />}
            </span>
          </div>

          <div className="login-row">
            <a href="#" className="login-forgot">Ai uitat parola?</a>
          </div>

          <button type="submit" className="login-btn">
            Conectare
          </button>
        </form>

        {message && <p className="login-message">{message}</p>}
      </div>
    </div>
  );
}

export default CCHLogin;
